export const XLSX_VIEWER_STRINGS = {
  DIALOG: {
    TITLE: 'Confirm Clear Mappings',
    CONTENT: 'Are you sure you want to clear these mappings?',
    CANCEL: 'Cancel',
    CONFIRM: 'Clear Mappings',
  },

  MENU: {
    CLEAR_ALL: 'Clear All Mappings for Current Measurement Date',
    CLEAR_DOCUMENT: 'Clear Current Document Mappings',
    CLEAR_SHEET: 'Clear Current Sheet',
    CLEAR_SHEET_SUFFIX: 'Mappings',
    CLEAR_MENU_TOOLTIP: 'Clear mappings',
  },

  BUTTON: {
    CREATE_LABELS: 'Create Labels',
    /** Primary XLSX toolbar action when starting/regenerating AI mappings from Financials */
    GENERATE_MAPPINGS: 'Generate mappings',
    PUSH_MAPPINGS: 'Push Mappings'
  },

  LOADING: {
    MESSAGE: 'Processing the document, this may take a moment...',
  },

  ERROR: {
    TITLE: 'Unable to load the workbook.',
    MESSAGE: 'This may be because the file is too large or there was a problem parsing the XLSX file.',
  },

  ARIA: {
    MENU_ID: 'split-button-menu',
  },
} as const;
